
/* GLDN – rekomendacje w koszyku: Shopify + slider + popup */
(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const MAX = 6;
  const cache = new Map();

  const money = value => new Intl.NumberFormat('pl-PL', {
    style: 'currency',
    currency: 'PLN'
  }).format(Number(value || 0) / 100);

  let requestId = 0;
  let timer;
  let modal;
  let activeButton;
  let adding = false;

  const host = () => document.getElementById('gldn-cart-upsell');

  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(renderRecommendations, 120);
  }

  async function recommendationHandles(cart, request) {
    const inCart = new Set(
      cart.items.map(item => String(item.product_id))
    );

    const seen = new Set(inCart);
    const handles = [];
    const sources = cart.items.slice(0, 4);

    async function collect(intent) {
      for (const item of sources) {
        if (handles.length >= MAX || request !== requestId) return;

        try {
          const url =
            `${ROOT}recommendations/products.json` +
            `?product_id=${item.product_id}` +
            `&limit=10&intent=${intent}`;

          const response = await fetch(url);
          if (!response.ok) continue;

          const data = await response.json();
          if (request !== requestId) return;

          for (const product of data.products || []) {
            const id = String(product.id);

            if (!product.handle || seen.has(id)) continue;
            if (product.available === false) continue;

            if (
              product.variants?.length &&
              !product.variants.some(v => v.available)
            ) continue;

            seen.add(id);
            handles.push(product.handle);

            if (handles.length >= MAX) break;
          }
        } catch (error) {
          console.warn(
            'GLDN – pobieranie rekomendacji:',
            error
          );
        }
      }
    }

    // Najpierw produkty z Search & Discovery
    await collect('complementary');

    // Jeśli mniej niż 3, uzupełnij produktami powiązanymi
    if (handles.length < 3 && request === requestId) {
      await collect('related');
    }

    return handles;
  }

  function getProduct(handle) {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(`${ROOT}products/${encodeURIComponent(handle)}.js`)
          .then(response => {
            if (!response.ok) {
              throw new Error(`Nie znaleziono: ${handle}`);
            }
            return response.json();
          })
          .catch(error => {
            cache.delete(handle);
            console.warn('GLDN – produkt:', error);
            return null;
          })
      );
    }

    return cache.get(handle);
  }

  function createCard(product) {
    const available = (product.variants || [])
      .filter(v => v.available);

    if (!available.length) return null;

    const item = document.createElement('article');
    item.className = 'gldn-cart-upsell__item';

    const photoLink = document.createElement('a');
    photoLink.className = 'gldn-cart-upsell__photo-link';
    photoLink.href = `${ROOT}products/${product.handle}`;

    const photo = document.createElement('img');
    photo.className = 'gldn-cart-upsell__photo';
    photo.src = product.featured_image || '';
    photo.alt = product.title;
    photo.loading = 'lazy';

    photoLink.append(photo);

    const details = document.createElement('div');
    details.className = 'gldn-cart-upsell__details';

    const name = document.createElement('a');
    name.className = 'gldn-cart-upsell__name';
    name.href = photoLink.href;
    name.textContent = product.title;

    const price = document.createElement('div');
    price.className = 'gldn-cart-upsell__price';
    price.textContent = money(available[0].price);

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gldn-cart-upsell__add';
    button.dataset.handle = product.handle;
    button.textContent = 'DODAJ';

    details.append(name, price, button);
    item.append(photoLink, details);

    return item;
  }

  async function renderRecommendations() {
    const request = ++requestId;
    const container = host();

    if (!container) return;

    try {
      const response = await fetch(`${ROOT}cart.js`, {
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Nie udało się pobrać koszyka');
      }

      const cart = await response.json();
      if (request !== requestId) return;

      const handles = cart.items.length
        ? await recommendationHandles(cart, request)
        : [];

      if (request !== requestId) return;

      const products = await Promise.all(
        handles.map(getProduct)
      );

      if (request !== requestId || !host()) return;

      const cards = products
        .filter(Boolean)
        .map(createCard)
        .filter(Boolean);

      const target = host();

      if (!cards.length) {
        target.replaceChildren();
        target.hidden = true;
        return;
      }

      const heading = document.createElement('h4');
      heading.className = 'gldn-cart-upsell__heading';
      heading.textContent = 'MOŻE JESZCZE TO?';

      const track = document.createElement('div');
      track.className = 'gldn-cart-upsell__list';
      track.setAttribute(
        'aria-label',
        'Polecane produkty – przesuń w bok'
      );
      track.append(...cards);

      const navigation = document.createElement('div');
      navigation.className = 'gldn-cart-upsell__navigation';

      for (const [direction, label, symbol] of [
        ['prev', 'Przewiń w lewo', '‹'],
        ['next', 'Przewiń w prawo', '›']
      ]) {
        const arrow = document.createElement('button');
        arrow.type = 'button';
        arrow.className = 'gldn-cart-upsell__arrow';
        arrow.dataset.direction = direction;
        arrow.setAttribute('aria-label', label);
        arrow.textContent = symbol;

        navigation.append(arrow);
      }

      target.replaceChildren(heading, track, navigation);
      target.hidden = false;

      requestAnimationFrame(() => {
        if (navigation.isConnected) {
          navigation.hidden =
            track.scrollWidth <= track.clientWidth + 2;
        }
      });

    } catch (error) {
      console.warn('GLDN – upsell w koszyku:', error);

      if (request === requestId && host()) {
        host().hidden = true;
      }
    }
  }

  function ensureModal() {
    if (modal) return modal;

    const inner = document.querySelector(
      '#MinimogCartDrawer .m-cart-drawer__inner'
    );

    if (!inner) return null;

    modal = document.createElement('div');
    modal.className = 'gldn-upsell-modal';
    modal.hidden = true;

    modal.innerHTML = `
      <div
        class="gldn-upsell-modal__box"
        role="dialog"
        aria-modal="true"
        aria-labelledby="gldn-upsell-title"
      >
        <button
          type="button"
          class="gldn-upsell-modal__close"
          aria-label="Zamknij"
        >×</button>

        <h3
          id="gldn-upsell-title"
          class="gldn-upsell-modal__title"
        ></h3>

        <p class="gldn-upsell-modal__label">
          WYBIERZ WARIANT
        </p>

        <div class="gldn-upsell-modal__variants"></div>

        <p
          class="gldn-upsell-modal__error"
          role="alert"
        ></p>
      </div>
    `;

    inner.append(modal);

    modal.addEventListener('click', event => {
      if (
        event.target === modal ||
        event.target.closest('.gldn-upsell-modal__close')
      ) {
        if (!adding) closeModal();
        return;
      }

      const option = event.target.closest(
        '.gldn-upsell-modal__variant'
      );

      if (option && !option.disabled && activeButton) {
        addProduct(
          Number(option.dataset.variant),
          activeButton
        );
      }
    });

    document.addEventListener('keydown', event => {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape' && !adding) {
        closeModal();
      }

      if (event.key !== 'Tab') return;

      const controls = [
        ...modal.querySelectorAll('button:not(:disabled)')
      ];

      const first = controls[0];
      const last = controls[controls.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last?.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first?.focus();
      }
    });

    return modal;
  }

  function closeModal() {
    if (!modal || modal.hidden) return;

    modal.hidden = true;

    if (activeButton?.isConnected) {
      activeButton.focus();
    }

    activeButton = null;
  }

  function showVariants(product, button) {
    const popup = ensureModal();
    if (!popup) return;

    activeButton = button;

    popup.querySelector(
      '.gldn-upsell-modal__title'
    ).textContent = product.title;

    popup.querySelector(
      '.gldn-upsell-modal__error'
    ).textContent = '';

    const optionName = String(
      product.options?.[0]?.name ||
      product.options?.[0] ||
      ''
    );

    popup.querySelector(
      '.gldn-upsell-modal__label'
    ).textContent = /size|rozmiar/i.test(optionName)
      ? 'WYBIERZ ROZMIAR'
      : 'WYBIERZ WARIANT';

    const choices = popup.querySelector(
      '.gldn-upsell-modal__variants'
    );

    choices.replaceChildren();

    for (const variant of product.variants) {
      const choice = document.createElement('button');

      choice.type = 'button';
      choice.className = 'gldn-upsell-modal__variant';
      choice.dataset.variant = String(variant.id);
      choice.dataset.available = String(variant.available);
      choice.textContent = variant.title;
      choice.disabled = !variant.available;

      if (!variant.available) {
        choice.title = 'Niedostępny';
      }

      choices.append(choice);
    }

    popup.hidden = false;

    popup.querySelector(
      '.gldn-upsell-modal__close'
    ).focus();
  }

  async function addProduct(variantId, button) {
    if (!variantId || adding || button.disabled) return;

    adding = true;
    button.disabled = true;
    button.textContent = 'DODAWANIE…';

    modal?.querySelectorAll(
      '.gldn-upsell-modal__variant'
    ).forEach(b => {
      b.disabled = true;
    });

    try {
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));

        throw new Error(
          error.description ||
          error.message ||
          'Nie udało się dodać produktu'
        );
      }

      closeModal();

      // Odświeżanie koszyka z Twojej wersji Minimog
      const cartBody = document.getElementById(
        'MinimogCartDrawerBody'
      );

      if (
        typeof cartBody?.onCartRefresh === 'function'
      ) {
        await cartBody.onCartRefresh({
          detail: { open: false }
        });
      } else {
        document.dispatchEvent(
          new CustomEvent('cart:refresh', {
            detail: { open: false }
          })
        );
      }

      scheduleRefresh();

    } catch (error) {
      console.error(
        'GLDN – dodawanie z rekomendacji:',
        error
      );

      button.disabled = false;
      button.textContent = 'SPRÓBUJ PONOWNIE';

      if (modal && !modal.hidden) {
        modal.querySelector(
          '.gldn-upsell-modal__error'
        ).textContent = error.message;

        modal.querySelectorAll(
          '.gldn-upsell-modal__variant'
        ).forEach(b => {
          b.disabled = b.dataset.available !== 'true';
        });
      }
    } finally {
      adding = false;
    }
  }

  function start() {
    const cartBody = document.getElementById(
      'MinimogCartDrawerBody'
    );

    const drawer = document.getElementById(
      'MinimogCartDrawer'
    );

    if (!cartBody || !drawer) return;

    // Reakcja na podmianę zawartości koszyka
    new MutationObserver(scheduleRefresh).observe(
      cartBody,
      { childList: true }
    );

    // Reakcja na otwarcie wysuwanego koszyka
    new MutationObserver(() => {
      if (
        drawer.classList.contains(
          'm-cart-drawer--active'
        )
      ) {
        scheduleRefresh();
      } else if (!adding) {
        closeModal();
      }
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    cartBody.addEventListener('click', async event => {
      const button = event.target.closest(
        '.gldn-cart-upsell__add'
      );

      if (button) {
        if (button.disabled || adding) return;

        button.disabled = true;

        const product = await getProduct(
          button.dataset.handle
        );

        button.disabled = false;

        if (!product || !button.isConnected) return;

        const available = (product.variants || [])
          .filter(v => v.available);

        if (!available.length) return;

        if (product.variants.length === 1) {
          addProduct(available[0].id, button);
        } else {
          showVariants(product, button);
        }

        return;
      }

      const arrow = event.target.closest(
        '.gldn-cart-upsell__arrow'
      );

      if (arrow) {
        const track = host()?.querySelector(
          '.gldn-cart-upsell__list'
        );

        track?.scrollBy({
          left: (
            arrow.dataset.direction === 'next'
              ? 1
              : -1
          ) * track.clientWidth * 0.8,
          behavior: 'smooth'
        });
      }
    });

    document.addEventListener(
      'cart:updated',
      scheduleRefresh
    );

    scheduleRefresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();
